import { ItemCard } from '@leverege/ui-attributes'
import { Button, Pane } from '@leverege/ui-elements'
import React, { useCallback, useState } from 'react'

import S from './ShelfCards.css'

export default function ShelfCards( props ) {
  const {
    paginator,
    settings : model
  } = props

  const [ segmentImageStates, setSegmentImageStates ] = useState( {} )
  const onChangeSegmentImageState = useCallback( ( { data } ) => {
    setSegmentImageStates( {
      ...segmentImageStates,
      [data] : !segmentImageStates[data]
    } )
  }, [ segmentImageStates ] )

  const context = {
    client : ShelfCards.CLIENT,
    clientProps : props,
  }

  return (
    <Pane variant="shelfGrid" className={S.shelf}>
      {paginator.pageItems.map( item => (
        <ItemCard
          key={item.id}
          model={model}
          variant="customItemContent"
          controls={(
            <ViewTypeAction
              value={segmentImageStates[item.id]}
              onChange={onChangeSegmentImageState}
              eventData={item.id} />
          )}
          context={{
            ...context,
            target : [ item ],
            imageView : segmentImageStates[item.id] ? 'pog' : 'segment'
          }}/>
      ) )}
    </Pane>
  )
}

function ViewTypeAction( { value, eventData, onChange } ) {
  return (
    <Button onClick={onChange} eventData={eventData} variant="cardActionLink">
      {value ? 'View Plan' : 'View Segment'}
    </Button>
  )
}

ShelfCards.CLIENT = 'ShelfCards'
